var GeometryType;
(function (GeometryType) {
    GeometryType["CONTOUR"] = "CONTOUR";
    GeometryType["SURFACE"] = "SURFACE";
})(GeometryType || (GeometryType = {}));
export default GeometryType;
